import React from 'react';
import throttle from "lodash/throttle";

import refreshBtn from '../../assets/img/mmh-table/refresh.svg'

const Refresh = (props) => {
    const { buttonTitle, refreshFunction } = props
    return (
        <button className="filter-refresh-button margin-right-1-rem" onClick={throttle(refreshFunction, 500)}>
            {/*<i className="flaticon-refresh"/>*/}
            {/*{buttonTitle || "Refresh"}*/}
            <i className="fa-solid fa-arrows-rotate"></i>
        </button>
    )
};

export default Refresh